import m from "./../../../dist/es2015/locales/ca_ES.js";
export const am5locales_ca_ES = m;